import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { mangaList } from "@/mocks/comics";

export default function FeaturedSection() {
  const featured = [...mangaList]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-labelledby="featured-title">
      <div className="container-site">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="chip-tag">
              <i className="ri-star-fill text-xs" aria-hidden="true" />
              编辑精选
            </span>
            <h2 id="featured-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              高分好评作品集结，口碑与热度兼得，入股不亏。
            </p>
          </div>
          <Link to="/category/all" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer">
            查看全部<i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.slug} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}